<template>
    <section class="product-card" :class="{'product-card-permission': !hasPermissionUnits && user.user_group == 'admin' || user.user_group == 'collaborator' || user.isDynamicGroup}" @mouseleave="menuUnits('close')" data-ui="product-card">
        <section class="cover">

            <div  class="image" :style="urlImage">
                <div class="status">{{ doWorks }}</div>

                <section class="price">
                    <small>A partir de:</small>
                    <div><span>R$</span> {{formatReal(vauleToProduct)}}</div>
                </section>

                <div class="product-link" @click.right.prevent @mouseup.prevent="setHref($event, `/empreendimentos/${data.id}/visualizar`)"/>

                <section v-if="hasPermissionUnits" class="units-menu">
                    <div  v-if="data.availability_id || (data.infos && data.infos.uauProductKey)">
                        <button type="button" @click="menuUnits()">
                            <em class="fas fa-grip-horizontal"/>
                        </button>
                    </div>
                </section>
                <div v-if="data.availability && data.availability.integration_erp && data.availability.integration_erp.type" class="integration" @mouseout="infoShow = true" @mouseleave="infoShow = false" >
                    <div v-if="data.availability.integration_erp && data.availability.integration_erp.type == 'uau'" class="integration-uau">
                        <img :src="require('@/assets/imgs/uau.jpeg')" height="35" alt="uau"/>
                    </div>
                    <div v-if="data.availability.integration_erp && data.availability.integration_erp.type == 'sienge'" class="integration-sienge">
                        <img :src="require('@/assets/imgs/Sienge.png')" height="10" alt="sienge"/>
                    </div>
                </div>
				<div v-if="filteredIntegrations.length > 0 && data.infos.informakon && data.infos.informakon === 'true' || (typeof data.infos.informakon === 'object' &&
					data.infos.informakon?.v === 'true')" class="integration" @mouseout="infoShow = true" @mouseleave="infoShow = false" >
						<div class="integration-uau">
							<img :src="require('@/assets/imgs/informakon.jpg')" height="35" alt="informakon"/>
						</div>
                </div>
                <section v-if="returnMenu" class="menu-steps" @mouseleave.prevent="menuSteps('close')">
                    <button type="button" @click.prevent="menuSteps()" data-ui="product-menu-card">
                        <em class="fal fa-ellipsis-v"/>
                    </button>
                    <div v-show="menuStepsStatus" class="options" data-ui="product-card-menu-options">
                        <ul>
                            <li>
                                <a  @click.right.prevent @mouseup.prevent="setHref($event, `/empreendimentos/etapa1/${data.id}`)">Etapa 1 - Dados do empreendimento</a>
                            </li>
                            <li v-if="hasPermissionUnits">
                                <a @click.right.prevent @mouseup.prevent="setHref($event, `/empreendimentos/etapa2/${data.id}`)">Etapa 2 - Disponibilidade e reservas</a>
                            </li>
                            <li v-if="hasPermissionUnits">
                                <a v-if="returnMenuStep || returnMenuStepSUM"  @click.right.prevent @mouseup.prevent="setHref($event, `/empreendimentos/etapa3/${data.id}`)">Etapa 3 - Gestão de unidades</a>
                            </li>
                            <li v-if="hasPermissionUnits">
                                <router-link v-if="returnMenuStep || returnMenuStepSUM" :to="{path: `/empreendimentos/etapa4/${data.id}`}" >Etapa 4 - Gestão de tabela de vendas</router-link>
                            </li>
							<li v-if="user.user_group == 'admin'">
                                <a @click="openConfigurations(data.id, data.name)">
									Configurações
								</a>
                            </li>
                        </ul>
                    </div>
                </section>
            </div>
        </section>

        <section class="infos" >
            <div class="type">
                <div>
                    <div class="tag">{{ typesOfRealEstate }}</div>
                </div>
                <div>
                    <div class="metrics"><em class="fal fa-vector-square"/> {{ squareMetrics }}</div>
                </div>
            </div>
            <div class="texts">
                <div class="title" :title="title">
                    <h3 >{{title}}</h3>
                </div>
                <div class="subtitle" :title="subTitle">
                    <p>{{subTitle}}</p>
                </div>
            </div>
        </section>

		<div v-if="hasPermissionUnits">
			<section v-if="user.user_group == 'admin' || user.user_group == 'collaborator' || user.isDynamicGroup" class="units">
				<div @mouseover="d = true" @mouseout="d = false">
					<strong> D: {{summary.available}} </strong> &nbsp;
					<div v-if="d" class="info">Disponíveis</div>
				</div>
				/ &nbsp;
				<div @mouseover="v = true" @mouseout="v = false">
					<strong> V: {{summary.sale}} </strong> &nbsp;
					<div v-if="v" class="info">Vendidas</div>
				</div>
				/ &nbsp;
				<div @mouseover="pr = true" @mouseout="pr = false">
					<strong> PR: {{summary.preReserve}} </strong> &nbsp;
					<div v-if="pr" class="info">Pré-reservas</div>
				</div>
				/ &nbsp;
				<div  @mouseover="r = true" @mouseout="r = false">
					<strong> R: {{summary.reserved}} </strong> &nbsp;
					<div v-if="r" class="info">Reservas</div>
				</div>
				/ &nbsp;
				<div @mouseover="rp = true" @mouseout="rp = false">
					<strong> RP: {{summary.reservedPemanently}} </strong> &nbsp;
					<div v-if="rp" class="info">Reservas permanentes</div>
				</div>
			</section>
		</div>

        <section class="footer-card" :class="{'footer-card-permission': !hasPermissionUnits && user.user_group == 'admin' || user.user_group == 'collaborator' || user.isDynamicGroup}">
            <section v-if="data.googleMaps" class="local" :style="{ 'cursor': 'pointer'}">
                <a
                    class="local"
                    @click.right.prevent
                    @mouseup.prevent="setHref($event, `http://maps.google.com/?ie=UTF8&hq=&ll=${data.googleMaps}`, true)"
                >
                    <div>
                        <i class="fal fa-map-marker-alt"/> {{district}} {{unitLocal}}
                    </div>
                </a>
            </section>

            <section v-else class="local" :style="{ 'cursor': 'default'}">
                <div>
                    <i class="fal fa-map-marker-alt"/> {{district}} {{unitLocal}}
                </div>
            </section>

            <section v-if="footerButton && !menuUnitsStatus" class="footer-button">
                <ui-button design="xs orange" @click="footerButtonAction(data.id)">{{ footerButton }}</ui-button>
            </section>
        </section>
        <!--aqui -->

        <div class="menu-overlay" :class="{'active': menuUnitsStatus}" @click="menuUnits('close')"/>
        <section class="options-menu" :class="{'active': menuUnitsStatus}"	>
            <h3>Espelho de Vendas</h3>
            <ul>
                <li>
                    <router-link :to="{ name: 'products.units', params: { id: data.id } }">
                        <span>Lista de unidades</span>
                        <em class="far fa-chevron-right" />
                    </router-link>
                </li>

                <li v-if="!data.infos.hide_electronic_plant">
                    <router-link
                        :to="{
                            name: data.availability?.type === 'vertical'
                                ? 'products.unitsVertical'
                                : 'products.unitsHorizontal',
                            params: { id: data.id }
                        }"
                    >
                        <span>Espelho digital</span>
                        <em class="far fa-chevron-right" />
                    </router-link>
                </li>

                <li v-if="!data.infos.hide_sales_mirror && data.availability?.type === 'horizontal'">
                    <router-link :to="{ name: 'products.deploymentImage', params: { id: data.id } }">
                        <span>Imagem de Implantação</span>
                        <em class="far fa-chevron-right" />
                    </router-link>
                </li>
            </ul>
        </section>
    </section>
</template>

<script>
import { uiButton } from "@/components/ui/buttons";
import helpers from '@/mixins/helpers';
import { storage } from '@/services/storage';
import { mapActions } from 'vuex';

export default {
	name: "product-card",
	components: {
		uiButton
	},
	mixins: [helpers],
	props: {
		data: {
			type: null,
			default: () => {}
		},
		integrationApiUau: {
			type: null,
			default: ''
		},
		footerButton: {
			type: String,
			default: ''
		},
		footerButtonAction: {
			type: Function,
			default: () => {
				return
			}
		},
		integrations: {
			type: [Object, Array],
			default: function () {
				return {}
			}
        },
	},
	data(){
		return {
			infoShow: false,
			titleInfoShow: false,
			menuStepsStatus: false,
			menuUnitsStatus: false,
			d: false,
			v: false,
			pr: false,
			r: false,
			rp: false,
			zIndex: 11,
			typesOfRealEstate: 'Sem Fase',
			doWorks: 'Sem Fase',
			squareMetrics: 'Sem Medida',
			district: 'Sem Local',
			unitLocal: null
		}
	},
	computed: {
		/**
		 * Verifica o tipo de usuário e traz o menu na tela
		 */
		user() {
			return JSON.parse(storage.get('user_logged'))
		},
		returnMenu() {
			return this.user.user_group != 'manager' &&
			this.user.user_group != 'supervisor' &&
			this.user.user_group != 'broker' ? true : false
		},
		/**
		 * Menu com o valor sienge uau
		 */
		returnMenuStepSUM() {
			return this.data?.availability?.integration_erp?.type &&
			(this.data.availability.integration_erp.type == 'sienge' ||
			this.data.availability.integration_erp.type == 'uau' ||
			this.data.availability.integration_erp.type == 'mega') ? true : false
		},
		returnMenuStep() {
			return (this.data?.availability &&
			!this.data.availability.integration_erp_id) &&
			(this.data.availability_id) ? true : false
		},
		/**
		 * Retorna a imagem do empreendimento
		 */
		urlImage(){
			let thisUrl = {'background-image': `url('${require('@/assets/imgs/no-product-image.png')}')`, 'background-size': 'cover'}
			if (this.data?.cover?.files_relational) {
				this.data.cover.files_relational.forEach((value) => {
					if (value.alias && value.alias == 'h200') {
						thisUrl =  {'background-image': `url('${value.url}')`, 'background-size': 'contain'}
					}
				})
			}
			return thisUrl
		},
		/**
		 * Retorna o nome do empreendimento
		 */
		title() {
			return this.data.name || 'Sem Titulo'
		},
		subTitle() {
			return this.data?.infos?.subtitle || 'Sem Subtitulo'
		},
		/**
		 * Retorna o resumo das quantidades de unidades por situação/status
		 */
		summary() {
			return {
				available: this.data?.['availability_summary']?.available ? this.data.availability_summary['available'] : '0',
				reserved: this.data?.availability_summary?.['reserved'] ? this.data.availability_summary['reserved'] : '0',
				sale: this.data?.availability_summary?.['sale'] ? this.data.availability_summary['sale'] : '0',
				reservedPemanently: this.data?.availability_summary?.['reserved-permanetly'] ? this.data.availability_summary['reserved-permanetly'] : '0',
				preReserve: this.data?.availability_summary?.['pre-reserve'] ? this.data.availability_summary['pre-reserve'] : '0'
			}
		},
		/**
		 * Retorna o valor do produto
		 */
		vauleToProduct(){
			let resultObj = {};
			if(this.data?.fields?.field_group){
				this.data.fields.field_group.forEach(val => {
					// eslint-disable-next-line no-useless-escape
					resultObj[val.field.slug.replace(/\-/g, "_")] = val.field.value ? val.field.value.value : '0';
				});
			}
			let result = resultObj?.valor_imovel && resultObj.valor_imovel != '' ? resultObj.valor_imovel : '0';
			return result
		},
		/**
		 * Retorna a versão da rota que utilizada para redirecionar para a imagem de
		 * implantação
		 */
		salesMirrorVersion() {
			const totalUnits = Object.values(this.unitsAvailable)
				.map(count => parseInt(count))
				.reduce((sum, count) => sum + count, 0)

			return totalUnits >= 800 ? '/versao/2' : ''
		},
		/**
		 * Computed property que define a rota para a lista das unidades do empreendimento
		 * de acordo com o tipo de integração, caso possua.
		 */
		unitsListRoute() {
			let route = ''
			if (this.data.availability_id) {
				route = (!this.data.availability.integration_erp ||
					(this.data.availability.integration_erp &&
						this.data.availability.integration_erp.version !== 'v2'))
						? `/empreendimentos/${this.data.id}/visualizar/lista`
						: this.$router.resolve({
							name: 'marketing.integrations.erp.units',
							params: { id: this.data.id }
						}).href
			}

			return  route
		},
		filteredIntegrations() {
            return this.integrations.filter(
                integration => integration.type === 'informakon' && integration.deleted_at === null
            )
        },

		hasPermissionUnits() {
			return this.data.permissionUnits
		}
	},

	mounted () {
		let key = Object.keys(this.data.items)
		key.forEach(value => {
			if(Array.isArray(this.data.items[value])) {
				this.setTypeName(this.data.items[value][0])
			}
		})
	},

	methods: {
		...mapActions('digitalSignatureStore', [
			'setProduct'
		]),

		//transforma o valor em moeda
		setTypeName(value) {
			switch(value.type_name) {
				case 'Tipo':
					this.typesOfRealEstate = value.item_name
					break
				case 'Status':
					this.doWorks = value.item_name
					break
				case 'Metragem':
					this.squareMetrics = value.item_name
					break
				case 'Cidade':
					this.district = value.item_name
					break
				case 'Bairro':
					this.unitLocal = '- ' + value.item_name
					break
			}
		},
		formatReal(int) {
			if (int === 0) {
				return 'R$ 0,00';
			}
			//verifica se ultimo numero é apos a virgula ou ponto
			let indexlastComma = int.lastIndexOf('.') != -1 ?
			int.lastIndexOf('.') : int.lastIndexOf(',') != -1 ?
			int.lastIndexOf(',') : -1

			//captura os valores após a ultima virgula ou ponto
			let valueFinalIndex = indexlastComma != -1 ? int.substring(indexlastComma + 1) : '00'
			const newValue = int.substring(0, indexlastComma)
			//remove todas as virgulas

			const removeComma = newValue.replace(/[^0-9]/g, '');

			const finalValue = `${removeComma}.${valueFinalIndex}`
			let tmp = Number(finalValue).toFixed(2).replace('.', ',');
			let neg = false;

			if (tmp.indexOf('-') === 0) {
				neg = true;
				tmp = tmp.slice(1);
			}

			tmp = tmp.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

			return neg ? '-' + tmp : tmp;
		},
		//sobe um menu
		menuSteps(action){
			switch (action) {
				case 'toogle':
					this.menuStepsStatus = !this.menuStepsStatus
					break;
				case 'close':
					this.menuStepsStatus = false
					break;
				case 'open':
					this.menuStepsStatus = true
					break;
				default:
					this.menuStepsStatus = !this.menuStepsStatus
			}
		},
		//idem
		menuUnits(action){
			switch (action) {
				case 'toogle':
					this.menuUnitsStatus = !this.menuUnitsStatus
					break;
				case 'close':
					this.menuUnitsStatus = false
					break;
				case 'open':
					this.menuUnitsStatus = true
					break;
				default:
					this.menuUnitsStatus = !this.menuUnitsStatus
			}
		},

		setHref(event, link, fullLink) {
			if(event.button == 0) fullLink ? window.open(link) : window.location.href = this.getUrlLegacy(link)
			else window.open(link)
		},

		openConfigurations(id, name) {
			let product= {
				id,
				name
			}
			this.setProduct(product)
			this.$router.push({ name: 'products.configurations', params: { id: id} })
		}
	}
}
</script>


<style lang="stylus" scoped>
	@import './styles.styl';
</style>
